import "core-js/modules/es.array.concat.js";
import styled from 'styled-components';
import { fontSmoothing } from '@finect/tabular-utils/fontSmoothing';
import { scrollX } from '@finect/tabular-utils/scrollX';
import { getFont } from '@finect/tabular-utils/getFont';
import { hideScrollbar } from '@finect/tabular-utils/hideScrollbar';
export var ResultItem = styled.li.withConfig({
  displayName: "ResultItem",
  componentId: "sc-1w2tzkr-0"
})(["display:flex;", " padding:12px;", ";", ";", " &:first-child{border-radius:", ";}&:last-child{border-radius:", ";}&:not(:last-child){border-bottom:1px solid ", ";}> *:first-child{margin-right:12px;}strong{padding-right:6px;}", ";"], scrollX, getFont(0), fontSmoothing, hideScrollbar, function (_ref) {
  var theme = _ref.theme;
  return "".concat(theme.borderRadius, " ").concat(theme.borderRadius, " 0 0");
}, function (_ref2) {
  var theme = _ref2.theme;
  return "0 0 ".concat(theme.borderRadius, " ").concat(theme.borderRadius);
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.borderColor;
}, function (_ref4) {
  var isSelected = _ref4.isSelected,
    theme = _ref4.theme;
  return isSelected ? "\n    background: ".concat(theme.colors.uiDD, ";\n    color: #fff;\n    cursor: pointer;\n    ") : '';
});